import React from 'react';

import { useTranslation } from 'react-i18next';

import { useRootSelector } from '@/router/state/root/util/context/helpers';

const OnboardingError: React.FC = () => {
  const { t } = useTranslation('common');
  const onboardingMachine = useRootSelector(state => state.children.onboardingMachine);
  const context = onboardingMachine?.getSnapshot()?.context;

  const handleRetry = () => {
    onboardingMachine!.send({ type: 'NEXT' });
  };

  return (
    <div className="flex h-full items-center justify-center">
      <div className="flex flex-col items-center justify-center text-destructive">
        <p>{t('onboarding.errorOccurred', { error: context?.error })}</p>
        <button
          className="mt-4 rounded bg-primary px-4 py-2 text-primary-foreground"
          onClick={handleRetry}
        >
          {t('retry')}
        </button>
      </div>
    </div>
  );
};

export default OnboardingError;
